/** @ngInject */
export default function stickyDirectiveConfig($timeout) {
    function link($scope, $element) {
        const scrollContainer = document.querySelector($scope.container);
        const from = parseInt($scope.dtStickyFrom, 10);
        const to = parseInt($scope.dtStickyTo, 10);
        const gutter = 16;
        let scrollTop = 0;

        function setFixedMode() {
            $element.css('top', `${from}px`)
                .addClass('sticky-fixed');

            if ($element[0].offsetHeight > scrollContainer.offsetHeight - from - to) {
                $element.css('bottom', `${to}px`);
            }
        }

        function removeFixedMod() {
            $element[0].scrollTop = 0;
            $element.removeClass('sticky-fixed');
        }

        function onScroll() {
            scrollTop = scrollContainer.scrollTop;
            $element.parent().css('min-height', `${$element[0].offsetHeight}px`);

            if (scrollTop > from + gutter) {
                setFixedMode();
            } else {
                removeFixedMod();
            }
        }

        $timeout(() => {
            onScroll();
        }, 1);

        scrollContainer.addEventListener('scroll', onScroll);

        $element.on('$destroy', () => {
            scrollContainer.removeEventListener('scroll', onScroll);
        });
    }

    return {
        restrict: 'A',
        scope: {
            container: '@',
            dtStickyFrom: '@',
            dtStickyTo: '@'
        },
        link
    };
}



// WEBPACK FOOTER //
// ./app/common/sticky/sticky.directive.js